import React, { useEffect, useState } from "react";
import SidebarItem from "./SidebarItem";
import {library} from '@fortawesome/fontawesome-svg-core';

import * as Icons from '@fortawesome/free-solid-svg-icons';

import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Drawer from '@mui/material/Drawer';

import "../../styles/main.css";
import testLogo from '../../assets/Test.png';
import logo_light from '../../assets/header/logo_light.png';
import logo_dark from '../../assets/header/logo_dark.png';
import logo_light_halloween from '../../assets/header/logo_light_halloween.png';
import logo_dark_halloween from '../../assets/header/logo_dark_halloween.png';
import logo_light_christmas from '../../assets/header/logo_light_christmas.png';
import logo_dark_christmas from '../../assets/header/logo_dark_christmas.png';
import Colors from "../../library/Colors";
import SftGlobalData from "../../library/SftGlobalData";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import EqualizerIcon from '@mui/icons-material/Equalizer';
import StoreIcon from '@mui/icons-material/Store';
import AddIcon from '@mui/icons-material/Add';
import UpdateIcon from '@mui/icons-material/Update';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import LineChartIcon from '@mui/icons-material/ShowChart';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import BrokenImageIcon from '@mui/icons-material/BrokenImage';
import KeyIcon from '@mui/icons-material/Key';
import crypto from 'crypto-js';
import MySoftTouch from '../../assets/application-icons/ic_mysft.png';
import MySales from '../../assets/application-icons/ic_mysales.png';
import MyFashionManager from '../../assets/licence-icons/office.png';
import Consultation from '../../assets/mobile-icons/ic_consultation.png';
import Collection from '../../assets/licence-icons/collection.png';
import Cloud from '../../assets/licence-icons/cloud.png';
import MyFasmanMobile from '../../assets/module-icons/ic_mobile.png';
import MyFasmanRevenue from '../../assets/application-icons/ic_revenue.png';
import Webshop from '../../assets/mobile-icons/ic_webshop.png';
import Integrations from '../../assets/licence-icons/integrations.png';
import Hardware from '../../assets/licence-icons/hardware.png';
import Others from '../../assets/licence-icons/other.png';
import axios from "axios";
import { Button, Collapse, Divider, FormControl, IconButton, InputAdornment, List, ListItemButton, ListItemText, OutlinedInput } from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import SearchIcon from '@mui/icons-material/Search';
import LeftSidebarMenu from "./LeftSidebarMenu";

let sftDb = {
    "id": "179",
    "db_id": "179",
    "client_id": "255",
    "user_id": "1001",
    "description": "SoftTouch-Vlaanderen leeuw",
    "is_active": "1",
    "is_owner": "1",
    "has_owner": 1,
    "settings": {"modAi": 0, "modExcel": 1, "modMobile": 1, "modPeppol": 0, "modEticket": 0, "modShipping": 1, "modScheduler": 1, "modUserManagement": 0, "modCustomerDisplay": 1},
    "created_at": "2022-03-22 16:24:19",
    "updated_at": "2026-04-16 15:34:00",
    "user_create": "1001",
    "user_modify": "1001",
    "logo": "https://logos.softtouch.eu/logo_179.jpeg",
    "is_sft": false,
    "sft_cust": "",
    "encrypted_key": "9C9C90419FD90CAA806172DA9447269067C49C2DCD6DDA67D02AD7F1D8B10DCC92D14F0980F01149CC3E48BF48EB9AF9F1A30658A6F61835CF2F6C7011F5C0A8C6028CCB54C3F744A151F344A6D4CC73892CC30F7E5F853E114D33B33D81E3892DC6C0167A65282DA4DA833351FD70AC60DB488D1A0B902A3A2E1B38EDC26277BF82EA88A538A8436F8A17C7CCB926368E64A05A6043FEE4ECF8806FDBF4E6EDEE26CB34A60030F193CAAC07DF95403DD922448F751EDAB3FAE392778B1EADA9AEEFC6404D218886389A8E51A6F721A43653D620312C2A2B3266CCEA85625122A47417986A283F708355A9AB2D257CE760925A3F307584B12BEC3644279EE468FA0E83DDD5C025081D313AAFD56A7DDE",
    "api_id": "-",
    "api_token": "-",
    "cust_no": "1276",
    "cust_url": "",
    "alt_name": "SoftTouch-Vlaanderen BV",
    "search_string": "",
    "cust_is_test": "0",
    "cust_is_local": "0",
    "cust_zone": "VL",
    "debug": ""
}
let testofzo = 0;
const LeftSidebar = (props) => {
  const [docs,setDocs] = useState([]);
  const [openSection, setOpenSection] = useState({});
  const [searchValue, setSearchValue] = useState("");
  const loggingModules = 
  props.sft_stat == "1" ? 
    ((props.group === "ADMIN" || props.group === "SUPER") ?
        [{name: "Add"}, {name: "rma"}, {name: "Logs"}, {name: "Customers"}, {name: "AdminStats"}, {name: "Manuals"}, {name: "Templates"}, {name: "Connections"}, {name: "User-info"}, {name: "Updates"}] 
        : [{name: "Add"}, {name: "rma"}, {name: "Logs"}, {name: "Customers"}, {name: "AdminStats"}, {name: "Manuals"}, {name: "Connections"}, {name: "User-info"}, {name: "Updates"}])
    : (props.sft_stat == "2" ? 
        [{name: "Add"}, {name: "rma"}, {name: "Logs"}, {name: "Customers"}, {name: "AdminStats"}, {name: "Manuals"}, {name: "Connections"}, {name: "User-info"}, {name: "Updates"}] : 
        (props.sft_stat == "3" ? [{name: "Add"}, {name: "Logs"}, {name: "Customers"}, {name: "AdminStats"}, {name: "Manuals"}, {name: "Connections"}, {name: "User-info"}, {name: "Updates"}] 
        : [])
      );
  let navigate = useNavigate();
  const location = useLocation();
  const params = useParams();

  if(testofzo === 7){
    SftGlobalData.easter1 = true;
  } else {
    SftGlobalData.easter1 = false;
  }
  
  //---------------------------------------------------------------------------------------------
  //    FUNCTIONS
  //---------------------------------------------------------------------------------------------
  
  const handleToggle = (applicationId) => {
    setOpenSection((prevSection) => (prevSection === applicationId ? null : applicationId));
  };

  const handleNavigation = (route) => {
    const loggingRoutes = ["Logs", "Add", "Customers"];
    let navigateAllowed = true
    if(location.pathname.includes("manuals/edit")){
        if(!SftGlobalData.confirmWindow(props.t('confirm_discard'))){
            navigateAllowed = false;
        }
    }
    if(route === "rma"){
        props.selectDb(sftDb, "9C9C90419FD90CAA806172DA9447269067C49C2DCD6DDA67D02AD7F1D8B10DCC92D14F0980F01149CC3E48BF48EB9AF9F1A30658A6F61835CF2F6C7011F5C0A8C6028CCB54C3F744A151F344A6D4CC73892CC30F7E5F853E114D33B33D81E3892DC6C0167A65282DA4DA833351FD70AC60DB488D1A0B902A3A2E1B38EDC26277BF82EA88A538A8436F8A17C7CCB926368E64A05A6043FEE4ECF8806FDBF4E6EDEE26CB34A60030F193CAAC07DF95403DD922448F751EDAB3FAE392778B1EADA9AEEFC6404D218886389A8E51A6F721A43653D620312C2A2B3266CCEA85625122A47417986A283F708355A9AB2D257CE760925A3F307584B12BEC3644279EE468FA0E83DDD5C025081D313AAFD56A7DDE");
    }
    if(loggingRoutes.includes(route)){
        if(props.screenWidth < 900){
          props.toggleMobileOpen();
        }
        if(navigateAllowed){
            navigate("/"+props.lang+"/logging/"+route.toLowerCase());
        }
    } else {
        if(route.toLowerCase() === "updates"){         
            window.open('https://changelog.softtouch.eu/' + props.lang + '/mysft/' + crypto.AES.encrypt(JSON.stringify({is_valid: props.login.is_valid, sft_group: props.login.sft_group, sft_status: props.login.sft_status, sft_user_id: props.login.sft_user_id}), 'Soft295Touch!').toString().replaceAll("/", "DIRTY_SLASH_FIX"), '_blank');
        } else {
            if(navigateAllowed){
                navigate("/"+props.lang+"/"+route.toLowerCase());       
            }
        }
    }
  }

  const checkPath = (route) => {
    const loggingRoutes = ["Logs", "Add", "Customers"];
    if(loggingRoutes.includes(route)){
      return "logging/"+route.toLowerCase();        
    } else {
        return route.toLowerCase();
    }
    
  }

  const getLogo = () => {
    switch(props?.holiday){
        case "halloween": return (props.theme==='dark') ? logo_dark_halloween : logo_light_halloween;
        case "christmas": return (props.theme==='dark') ? logo_dark_christmas : logo_light_christmas;
        default: return (props.theme==='dark') ? logo_dark : logo_light;
    }
  }

  const getLogModules = loggingModules.map(function(data) {
        if(SftGlobalData.debug){
            console.log("data: ", data);
        }

        return (
            <ListItem /*className={'sidebaritem_item_' + props.theme}*/key={data.name} button onClick={()=>{handleNavigation(data.name)}}
                sx={{
                    borderRadius: 1,
                    mt: 3,
                    height: 50,
                    maxHeight: 60,
                    borderRight: (props.pathname === checkPath(data.name) || (data.name.toLowerCase() === "logs" && props.pathname === "logging")) ? 5 : 0,
                    color:
                    (props.pathname === checkPath(data.name) || (data.name.toLowerCase() === "logs" && props.pathname === "logging"))
                        ? Colors.sft_blue
                        : '#969FA9',
                }}>
                {<ListItemIcon className={'sidebaritem_item__img '} 
                    sx={{
                      minWidth:30,
                      color: (props.pathname === checkPath(data.name) || (data.name.toLowerCase() === "logs" && props.pathname === "logging")) ? Colors.sft_blue: '#969FA9',
                    }}>
                    {data.name==="Logs" && <SupportAgentIcon />}
                    {data.name==="Add" && <AddIcon />}
                    {data.name==="Customers" && <StoreIcon />}
                    {data.name==="Connections" && <KeyIcon />}
                    {data.name==="Statistics" && <LineChartIcon />}
                    {data.name==="AdminStats" && <EqualizerIcon />}
                    {data.name==="Manuals" && <LibraryBooksIcon />}
                    {data.name==="Templates" && <FolderOpenIcon />}
                    {data.name==="Updates" && <UpdateIcon />}
                    {data.name==="User-info" && <ManageAccountsIcon />}
                    {(props.is_sft && data.name==="rma") && <BrokenImageIcon />}

                    {/*<img src={modIcon} width="30px" alt={props.data.module}/>*/}
                </ListItemIcon>}
            </ListItem>
        );
});

 const getApplicationIcon = (names) => {
    switch (names){
        case "1":
        case "MySales": 
            return MySales;
        case "2":
        case "MyFashionManager": 
            return MyFashionManager;
        case "3":
        case "Consultation": 
            return Consultation;
        case "4":
        case "Collection": 
            return Collection;
        case "5":
        case "Cloud": 
            return Cloud;
        case "6":
        case "MyFasman Mobile": 
            return MyFasmanMobile;
        case "7":
        case "MyFasman Revenue": 
            return MyFasmanRevenue;
        case "8":
        case "Webshop": 
            return Webshop;
        case "9":
        case "Integrations": 
            return Integrations;
        case "10":
        case "Hardware": 
            return Hardware;
        case "11":
        case "MySoftTouch":
            return MySoftTouch;
        default:
        case "12":
        case "Others": 
            return Others;       
    }
  }

 useEffect(()=>{
    //console.log("SIDEBAR", props.screen)
    if(props.screen === "help"){
        let postData = {key: props.api, visibility: (props.login?.sft_status != "0" ? props.login?.sft_group : "CUST"), language: params.lang};
        SftGlobalData.post('docs&action=sidebar', postData).then(response => {
              setDocs(response.data);
        });
    }
 }, [props.api, props.login, props.screen, props.lang])


 const getHelp = docs.map((menu, idx) => (
    <React.Fragment key={menu.application_id}>
          {/* Main menu item */}
          <ListItem disablePadding style={{marginTop: 10}}>
            <ListItemButton onClick={() => {handleToggle(menu.application_id); navigate("/"+params.lang+"/kb/application/"+menu.application_id);}}>
              <ListItemIcon className={'sidebaritem_item__img '}>
                {<img src={getApplicationIcon(menu.application_id+"")} width="24px" alt={menu.application_name}/>}
              </ListItemIcon>
              <ListItemText primary={menu.application_name} primaryTypographyProps={{ fontWeight: 'bold', fontSize: 14 }} />
              {openSection === menu.application_id ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
          </ListItem>
          
          {/* Collapsible sub-items */}
          <Collapse in={openSection === menu.application_id} timeout="auto" unmountOnExit>
            <List component="div" disablePadding sx={{ pl: 4 }}>
              {menu.docs.map((doc) => (
                <ListItemButton style={{paddingTop: 0, paddingBottom: 0}} key={doc.id} disablePadding onClick={()=>{navigate("/"+params.lang+"/kb/"+doc.id)}}>
                  <ListItemText primary={doc.title} primaryTypographyProps={{ fontSize: 12 }}/>
                </ListItemButton>
              ))}
            </List>
          </Collapse>
        </React.Fragment>
      ));

  const iconList = Object.keys(Icons)
    .filter((key) => key !== 'fas' && key !== 'prefix')
    .map((icon) => Icons[icon]);

  library.add(...iconList);

  /*const handleToggler = () => {
    props.setMenuExpanded(!props.menuExpanded);
    if(SftGlobalData.debug){
        console.log('sideBarCollapsed', props.menuExpanded);
    }
    localStorage.setItem('left_sidebar-collapsed', props.menuExpanded);

  }*/

    const handleMouseDown = (event) => {
        event.preventDefault();
    };
    
    const handleSearch = () => {
        navigate("/"+props.lang+"/kb/search/"+searchValue);
    }

    const switchLanguage = (newLang) => {
        // Split the current path into parts
        const pathParts = location.pathname.split('/');
    
        // Replace the first segment (language) with the new language
        pathParts[1] = newLang;
    
        // Reconstruct the new path
        const newPath = pathParts.join('/');
    
        // Navigate to the new path
        navigate(newPath);
      };

  return (
    <Box className={props.theme+"_accent no-print"} sx={{ display: 'flex' }}>
      <CssBaseline className={props.theme+"_accent "} />
      <Box
        className={props.theme+"_accent "}
        component="nav"
        sx={{ width: { sm: props.drawerWidth }, flexShrink: { sm: 0 } }}
        aria-label="mailbox folders"
      >
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Drawer
          className={props.theme}
          variant="temporary"
          open={props.mobileOpen}
          onClose={()=>{props.toggleMobileOpen()}}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: props.drawerWidth, backgroundColor: (props.theme === 'dark' ? Colors.dark_basic : Colors.light_basic) },
          }}
        >
            {props.screen !== "logging" && <LeftSidebarMenu 
                                                testofzo={testofzo} 
                                                modules={[
                                                    ((props?.modules?.modIntegrations || props?.modules?.modShipping || props?.modules?.modWebshop) && {group: "ONLINE INTEGRATIONS", groupData: [
                                                        props?.modules?.modIntegrations && {module: "integrations", name: "Integrations", active: 1},
                                                        props?.modules?.modShipping && {module: "shipping", name: "Shipping", active: 1},
                                                        props?.modules?.modWebshop && {module: "webshop", name: "Webshop", active: 1},
                                                    ].filter(Boolean), visible: 1}),
                                                    ((props?.modules?.modCustomerDisplay || props?.modules?.modEticket) && {group: "IN-STORE OPERATIONS", groupData: [
                                                        props?.modules?.modCustomerDisplay && {module: "customer-display", name: "Customer Display", active: 1},
                                                        props?.modules?.modEticket && {module: "eticket", name: "E-ticket", active: 1},
                                                    ].filter(Boolean), visible: 1}),
                                                    ((props?.modules?.modAi || props?.modules?.modBirthday || props?.modules?.modMailIntegrations) && {group: "MARKETING", groupData: [
                                                        props?.modules?.modAi && {module: "ai", name: "AI-Text generation", active: 1},
                                                        props?.modules?.modBirthday && {module: "birthday", name: "Birthday SMS", active: 1},
                                                        props?.modules?.modMailIntegrations && {module: "mail-integrations", name: "Mail integrations", active: 1},
                                                    ].filter(Boolean), visible: 1}),
                                                    ((props?.modules?.modExact || props?.modules?.modLicence || props?.modules?.modMobile || props?.modules?.modPeppol || props?.modules?.modRma || props?.modules?.modScheduler || props?.modules?.modUserManagement) && {group: "ADMINISTRATION", groupData: [
                                                        props?.modules?.modExact && {module: "exact", name: "Exact Online", active: 1},
                                                        props?.modules?.modLicence && {module: "licence", name: "Licence module", active: 1},
                                                        props?.modules?.modMobile && {module: "mobile", name: "MyFasMan Mobile", active: 1},
                                                        props?.modules?.modPeppol && {module: "peppol", name: "Peppol", active: 1},
                                                        props?.modules?.modRma && {module: "rma", name: "RMA", active: 1},
                                                        props?.modules?.modScheduler && {module: "scheduler", name: "Scheduler", active: 1},
                                                        props?.modules?.modUserManagement && {module: "users", name: "User management", active: 1}
                                                    ].filter(Boolean), visible: 1}),
                                                ].filter(Boolean)}
                                                theme={props.theme} 
                                                lang={props.lang} 
                                                menuExpanded={props.menuExpanded} 
                                                toggleMobileOpen={()=>{props.toggleMobileOpen()}} 
                                                db={props.db} 
                                                group={props.group} 
                                                screen={props.screen} 
                                                is_sft={props.is_sft} 
                                            />}
            {props.screen === "logging" && <div className={'sidebar_header ' + props.theme + (testofzo === 7 ? " pink" : "")}> {getLogModules} </div>}
        </Drawer>
        <Drawer
          className={props.theme}
          variant="permanent"  
          sx={{
            display: { xs: 'none', sm: 'block' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: props.drawerWidth, backgroundColor: (props.theme === 'dark' ? Colors.dark_basic : Colors.light_basic) },
          }}
          open
        >
        <div className={props.theme + " sidebar-left"}>
            <div className={"logo _100perc "} onClick={()=>{if(SftGlobalData.easter2){testofzo++;}}} style={{backgroundColor: (props.theme === 'dark' ? Colors.dark_basic : Colors.light_basic), padding: '10px', display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                {props.screen !== "logging" && <img alt="SoftTouch Logo" style={{width: '100%', maxWidth: 180, height: 'auto', objectFit: 'contain'}} src={getLogo()} onClick={()=>{if(props.is_sft){navigate("/"+props.lang+"/environment");}}}/>}
            </div>
            <div className="sidebar_items" style={{ paddingTop:0 }}>
                {(props.screen !== "logging" && props.screen !== "help") && <LeftSidebarMenu testofzo={testofzo} modules={[
                                                    ((props?.modules?.modIntegrations || props?.modules?.modShipping || props?.modules?.modWebshop) && {group: "ONLINE INTEGRATIONS", groupData: [
                                                        props?.modules?.modIntegrations && {module: "integrations", name: "Integrations", active: 1},
                                                        props?.modules?.modShipping && {module: "shipping", name: "Shipping", active: 1},
                                                        props?.modules?.modWebshop && {module: "webshop", name: "Webshop", active: 1},
                                                    ].filter(Boolean), visible: 1}),
                                                    ((props?.modules?.modCustomerDisplay || props?.modules?.modEticket) && {group: "IN-STORE OPERATIONS", groupData: [
                                                        props?.modules?.modCustomerDisplay && {module: "customer-display", name: "Customer Display", active: 1},
                                                        props?.modules?.modEticket && {module: "eticket", name: "E-ticket", active: 1},
                                                    ].filter(Boolean), visible: 1}),
                                                    ((props?.modules?.modAi || props?.modules?.modBirthday || props?.modules?.modMailIntegrations) && {group: "MARKETING", groupData: [
                                                        props?.modules?.modAi && {module: "ai", name: "AI-Text generation", active: 1},
                                                        props?.modules?.modBirthday && {module: "birthday", name: "Birthday SMS", active: 1},
                                                        props?.modules?.modMailIntegrations && {module: "mail-integrations", name: "Mail integrations", active: 1},
                                                    ].filter(Boolean), visible: 1}),
                                                    ((props?.modules?.modExcel || props?.modules?.modExact || props?.modules?.modLicence || props?.modules?.modMobile || props?.modules?.modPeppol || props?.modules?.modRma || props?.modules?.modScheduler || props?.modules?.modUserManagement) && {group: "ADMINISTRATION", groupData: [
                                                        props?.modules?.modExact && {module: "exact", name: "Exact Online", active: 1},
                                                        props?.modules?.modExcel && {module: "excel", name: "Excel", active: 1},
                                                        props?.modules?.modLicence && {module: "licence", name: "Licence module", active: 1},
                                                        props?.modules?.modMobile && {module: "mobile", name: "MyFasMan Mobile", active: 1},
                                                        props?.modules?.modPeppol && {module: "peppol", name: "Peppol", active: 1},
                                                        props?.modules?.modRma && {module: "rma", name: "RMA", active: 1},
                                                        props?.modules?.modScheduler && {module: "scheduler", name: "Scheduler", active: 1},
                                                        props?.modules?.modUserManagement && {module: "users", name: "User management", active: 1}
                                                    ].filter(Boolean), visible: 1}),
                                                ].filter(Boolean)} theme={props.theme} lang={props.lang} menuExpanded={props.menuExpanded} toggleMobileOpen={()=>{props.toggleMobileOpen()}} db={props.db} group={props.group} screen={props.screen} is_sft={props.is_sft} />}
                {props.screen === "help" && <div className="rowContainerBetween" style={{margin: 10}}>
                    <Button style={(props.lang === "nl" ? {fontWeight: "bold"} : {})} onClick={()=>switchLanguage("nl")}>NL</Button> 
                    <Button style={(props.lang === "fr" ? {fontWeight: "bold"} : {})} onClick={()=>switchLanguage("fr")}>FR</Button> 
                    <Button style={(props.lang === "en" ? {fontWeight: "bold"} : {})} onClick={()=>switchLanguage("en")}>EN</Button>
                </div>}
                {props.screen === "help" && <FormControl style={{marginTop: 5}} sx={{ m: 1, width: '100%', margin: '0' }}>
                    <OutlinedInput
                        id="outlined-adornment"
                        type={'text'}
                        name="txtSearch" 
                        className={props.theme+"_accent"}
                        value={searchValue}
                        onChange={(event)=>{setSearchValue(event.target.value)}}
                        onKeyDown={(event) => {
                            if (event.key === 'Enter') {
                                handleSearch();
                            }
                        }}
                        placeholder={props.t('search')}
                        endAdornment={
                            <InputAdornment position="end">
                                <IconButton
                                aria-label="search"
                                onClick={handleSearch}
                                onMouseDown={handleMouseDown}
                                edge="end"
                                >
                                <SearchIcon />
                                </IconButton>
                            </InputAdornment>
                        }
                    />
                </FormControl>}
                {props.screen === "help" && <List>{getHelp}</List>}
                {props.screen === "logging" && <div className={'sidebar_header ' + props.theme + (testofzo === 7 ? " pink" : "")}> {getLogModules} </div>}
                
            </div>
        </div>
        </Drawer>
      </Box>
    </Box>
  );
};

export default LeftSidebar;